var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:({
    backgroundColor: _vm.background !== undefined ? _vm.background : null,
    color: _vm.textColor !== undefined ? _vm.textColor : null
  }),attrs:{"role":_vm.role}},[_vm._t("default"),(_vm.separator)?_c('mks-separator',{attrs:{"color":_vm.separatorColor}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }